export default "__VITE_PUBLIC_ASSET__8beada8b__"